<template>
  <BaseTemplate :currentUser="currentUser">
    <div class="buy-product-history">
      <Title :jpn="t('履歴')" />
      <HistoryHeader />
      <HistoryTable
        v-if="dispHistoryList && dispHistoryList.length > 0"
        class="history-table"
        :historyList="dispHistoryList"
        :headerNameList="headerNameList"
        :dispKeyList="dispKeyList"
        :headerWidthList="headerWidthList"
        :isHistory="true"
        @handleClick="handleClick"
      />
      <div
        v-if="!(dispHistoryList && dispHistoryList.length > 0)"
        class="no-history"
      >
        <span>There is no product purchase history.</span>
      </div>
      <BoxPager
        v-if="dispHistoryList &&
          dispHistoryList.length > 0 &&
          purchaseHistoryList &&
          purchaseHistoryList.page.pages.length > 0
        "
        class="box-pager"
        :totalPageCount="purchaseHistoryList.page.all_page"
        :currentPageCount="purchaseHistoryList.page.page"
        :dispBoxCount="purchaseHistoryList.page.pages.length"
        :pages="purchaseHistoryList.page.pages"
        @handlePagerClick="changeCurrentPageCount"
        @handleSquareBtnClick="changeCurrentPageCount"
      />
    </div>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';

import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import HistoryTable from '@/components/organisms/HistoryTable02.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import Title from '@/components/molecules/Title02.vue';
import HistoryHeader from '@/components/molecules/HistoryHeader.vue';
import t from '@/plugins/i18n';

export default {
  name: 'BuyPurchaseHistory',
  mixins: [t],

  components: {
    BaseTemplate,
    HistoryTable,
    BoxPager,
    Title,
    HistoryHeader,
  },

  data: () => ({
    headerNameList: [],
    dispKeyList: [
      'buyDate',
      'purchaseId',
      'trackingNumber',
      'paymentMethod',
      'appraisedAmount',
      'detail',
    ],
    headerWidthList: ['10%', '20%', '20%', '20%', '20%', '10%'],
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      purchaseHistoryList: 'purchaseList/resultPurchaseHistoryList',
      selectedMode: 'packHistory/selectedMode',
    }),
    dispHistoryList() {
      if (this.purchaseHistoryList && this.purchaseHistoryList.list.length > 0) {
        return this.purchaseHistoryList.list.map((item) => {
          const itemId = item.id; // LINT回避用
          return {
            id: itemId,
            buyDate: item.created.split(' ')[0].replace(/-/g, '/').slice(2), // 例: "25/02/26"
            purchaseId: item.card_purchase_id, // 買取受付番号
            trackingNumber: item.tracking_number, // 追跡番号
            paymentMethod: this.getPaymentMethod(item.payment_method),
            appraisedAmount: item.total_price, // 査定額
          };
        });
      }
      return [];
    },
  },

  created() {
    const pageNumber = 1;
    this.$store.dispatch('purchaseList/historyList', { pageNumber });
    this.headerNameList = [
      this.t('日時'),
      this.t('買取受付番号'),
      this.t('追跡番号'),
      this.t('査定額のお受け取り方法'),
      this.t('査定額'),
      this.t('詳細'),
    ];
  },

  methods: {
    changeCurrentPageCount(pageNumber) {
      this.$store.dispatch('purchaseList/historyList', { pageNumber });
    },
    goToPurchaseHistoryDetail(historyId) {
      this.$router.push({ path: '/purchase-history-detail', query: { historyId } });
    },
    handleClick(dispKey, item) {
      this.goToPurchaseHistoryDetail(item.id);
    },
    getPaymentMethod(paymentMethod) {
      const methods = {
        1: '振込',
        2: 'PayPal',
        3: 'Coin',
      };
      return methods[paymentMethod] || '不明'; // 未定義の値は "不明" を表示
    },
  },
};
</script>

<style lang="scss" scoped>
$pagerWidth: 100%;

.buy-product-history{
  position: relative;
  width: 100%;
  max-width: 1000px;
  min-height: 100%;
  padding: 30px 20px 90px;
  margin: 0px auto;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  @media screen and (min-width:767px){
    max-width: 580px;
  }
  @media screen and (min-width:1023px){
    max-width: 1000px;
  }
  .box-pager{
    bottom: 30px;
    width: $pagerWidth;
    height: 30px;
    margin: 0px auto;
  }
  .no-history{
    margin-top: 20px;
    font-family: $notoSans;
    font-size: 14px;
    line-height: 2.25;
    color: $white;
    text-align: center;
  }
}
@media screen and  (max-width: $tabletWidth) {
  .buy-product-history{
    padding: 30px 0 90px;
    .history-table{
      .history-table-body {
        font-size: 12px;
      }
    }
  }
}
</style>
